module.exports = __webpack_public_path__ + "img/ringPerimeter@2x.e0936be.webp";